module.exports = global["async"] = require("-!./async.js");


//////////////////
// WEBPACK FOOTER
// ./~/async/lib/async.js-exposed
// module id = 371
// module chunks = 3